import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import { DemoScheduler } from "@/components/seo/DemoForm";
import { fmtSlot } from "@/components/booking/SlotPicker";

export default function DemoSchedulePage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  usePageMeta("Schedule your demo", "Pick a time for your ShopAdvisor demo.");
  useEffect(() => { api.get(`/api/seo/demo/${token}`).then(r => setD(r.data)).catch(() => setD(false)); }, [token]);
  return (
    <div className="min-h-screen bg-slate-50 pt-28 pb-16 px-4" data-testid="demo-schedule-page">
      <div className="max-w-xl mx-auto bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        {d === null ? <Loader2 className="w-6 h-6 animate-spin text-blue-600" /> : d === false ? <p data-testid="demo-schedule-missing">This scheduling link isn't valid. <Link to="/demo" className="text-blue-600 font-semibold">Request a demo</Link></p> : <>
          <h1 className="text-3xl font-bold text-slate-900">Hi {d.name.split(" ")[0]}, pick a time</h1>
          <p className="text-slate-600">Free {d.intent === "migration" ? "migration consultation" : "demo"} for {d.business_name}.</p>
          {d.booking?.status === "booked" ? <p className="bg-green-50 border border-green-200 rounded-xl p-3" data-testid="demo-schedule-booked">You're booked for <b>{fmtSlot(d.booking.start_at)}</b>. <a href={d.booking.join_link} className="font-bold underline">Join link</a></p> : <DemoScheduler token={token} />}
        </>}
      </div>
    </div>
  );
}
